import { render, staticRenderFns } from "./EditRouter.vue?vue&type=template&id=33bba92f&"
import script from "./EditRouter.vue?vue&type=script&lang=js&"
export * from "./EditRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports